import React from 'react';
import classNames from 'classnames';

import {ErrorField} from 'components/Fields';

import MoneyInput from 'components/MoneyInput';

import './styles.css';

const MoneyField = ({
  input: {onChange, onBlur, value},
  placeholder,
  className,
  min,
  step,
  meta: {touched, error}
}: any) => {
  return (
    <div
      className={classNames('MoneyField', className, {
        error: touched && error
      })}>
      <MoneyInput
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        min={min}
        step={step}
        value={value}
      />
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default MoneyField;
